export function customQuestionNames(_sender: any, options: any) {
  const { question } = options;
  const type = question.getType();

  if (type === 'dtcountrymultilangual') {
    question.name = 'BcountryGlobal';
  }
  if (type === 'dtcountrynew') {
    question.name = 'Bcountry';
  }
}
